import hexToHsl from 'hex-to-hsl'

class Color {
  static lightness (color) {
    return hexToHsl(color)[2]
  }
}

export default Color
